var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpdateLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "chevron-left"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0893 3.57757C13.4147 3.90301 13.4147 4.43065 13.0893 4.75609L7.84522 10.0002L13.0893 15.2442C13.4147 15.5697 13.4147 16.0973 13.0893 16.4228C12.7639 16.7482 12.2362 16.7482 11.9108 16.4228L6.07745 10.5894C5.75201 10.264 5.75201 9.73634 6.07745 9.41091L11.9108 3.57757C12.2362 3.25214 12.7639 3.25214 13.0893 3.57757Z",
    fill: "#666666"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdateLeft);
export default __webpack_public_path__ + "static/media/update-left.ba59f945094e9547f8163dd11b9c66c1.svg";
export { ForwardRef as ReactComponent };